import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AdOptions } from 'capacitor-admob';
import { Plugins } from '@capacitor/core';
import { RootState, selectors, actions } from '../store';
import PlaceList from '../components/PlaceList';
import SkeletonLoading from '../components/SkeletonLoading';
import PlaceListFilter from '../components/PlaceListFilter';
import { RouteComponentProps } from 'react-router';
import {
  IonRefresher, IonRefresherContent,
  IonInfiniteScroll, IonInfiniteScrollContent,
  withIonLifeCycle, IonPage, IonModal, IonIcon,
  IonHeader, IonToolbar, IonButtons, IonMenuButton,
  IonSegment, IonSegmentButton, IonButton, IonSearchbar,
  IonContent, IonAlert,
} from '@ionic/react';
import './HomePage.css';
import { options as optionsIcon } from 'ionicons/icons';
import { Place } from '../store/places/types';
import { Token } from '../store/users/types';

const { AdMob } = Plugins;

type Props =  RouteComponentProps<{}> & typeof mapDispatchToProps & ReturnType<typeof mapStateToProps>;

type State = {
  isRefreshing: boolean,
  showLoading: boolean,
  showFilterModal: boolean,
  loadingMore: boolean,
  text: string,
  loadingMessage: string,
  page: number,
  timer: any,
  items: any,
  intervalCount: number,
}

class HomePage extends Component<Props, State> {
  ionRefresherRef: React.RefObject<HTMLIonRefresherElement>
  state = {
    isRefreshing: false,
    showLoading: false,
    loadingMore: false,
    showFilterModal: false,
    loadingMessage: '',
    items: [],
    totalCount: 496,
    text: '',
    page: 1,
    intervalCount: 20,
    timer: setTimeout(() => {}, 2000),
  }

  constructor(props: Props) {
    super(props);
    const options: AdOptions = {
      adId: 'ca-app-pub-2796376641761374/6503333672',
      autoShow: false
    }
    setTimeout(() => {
      AdMob.prepareInterstitial(options)
        .then(
          async (value: any) => {
            if (value) {
              AdMob.showInterstitial()
            }
          },
          (error: any) => {
            console.error(error); // show error
          }
        );
    }, 2000)

    this.ionRefresherRef = React.createRef<HTMLIonRefresherElement>();
  }

  // async ionViewDidEnter() {
  //   if (this.props.tokens && this.props.tokens.id_token) {
  //     return;
  //   }
  //   const tokens: Token = await localForage.getItem('tokens');
  //   const todayTime = new Date().getTime();
  //   if (tokens && tokens.refresh_token) {
  //     if (!tokens.expired_at || tokens.expired_at < todayTime) {
  //       this.props.refreshTokens(tokens.refresh_token);
  //     } else {
  //       this.props.setTokens(tokens);
  //     }
  //   }
  // }

  loadMoreParks = (event: CustomEvent<void>) => {
    if (this.props.allFiltered.length <= this.props.placesOnDisplayInHome.length) {
      if (this.state.loadingMore) {
        this.setState({
          ...this.state,
          loadingMore: false,
        });
      }
      return;
    }
    this.setState({
      ...this.state,
      loadingMore: true,
    });
    const page = this.state.page + 1;
    const start = (page - 1) * this.state.intervalCount;
    const end = start + this.state.intervalCount;
    const nextItems = this.props.allFiltered.slice(start, end);
    const items = JSON.parse(JSON.stringify(this.props.placesOnDisplayInHome));
    this.props.showPlacesOnDisplay(items.concat(nextItems));
    this.setState({
      ...this.state,
      loadingMore: false,
      page,
    });
    event && (event.target as any).complete();
  };

  updateSearchTerm = (e: CustomEvent) => {
    const ionContent = document.querySelector('ion-content');
    this.setState({
      ...this.state,
      text: e.detail.value,
      loadingMore: true,
      page: 1,
    });
    if (this.state.timer !== null) {
      clearTimeout(this.state.timer);
    }
    
    const timerTimeout = setTimeout(async () => {
      await this.props.searchPlaces(e.detail.value);
      this.props.showPlacesOnDisplay(this.props.allFiltered.slice(0, 10));
      this.setState({
        ...this.state,
        loadingMore: false,
      });
      if (ionContent) {
        ionContent.scrollToTop(500);
      }
    }, 500);
    this.setState({
      ...this.state,
      timer: timerTimeout,
    });
  }

  updateStateFilter = (data: any) => {
    const currentStateFilter = this.props.stateFilters;
    const isSame = currentStateFilter.join(',') === data.join(',');
    if (isSame) {
      return;
    }
    this.props.updateStateFilters(data);
    this.setState({
      ...this.state,
      loadingMore: true,
    });
    const ionContent = document.querySelector('ion-content');
    // eslint-disable-next-line
    const timeout = setTimeout(async () => {
      this.props.showPlacesOnDisplay(this.props.allFiltered.slice(0, 10));
      this.setState({
        ...this.state,
        loadingMore: false,
      });
      if (ionContent) {
        ionContent.scrollToTop(500);
      }
    }, 500);
  }

  doRefresh = (e: CustomEvent) => {
    this.props.searchPlaces(this.state.text);
    this.setState(() => ({ 'isRefreshing': true }));
    e && (e.target as any).complete();
  }

  presentFilter = () => {
    this.setState(() => ({
      showFilterModal: true
    }));
  };

  dismissFilter = () => {
    this.setState(() => ({
      showFilterModal: false,
    }));
  };

  render() {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonMenuButton />
            </IonButtons>
            <IonSegment value="visited">
              <IonSegmentButton value="visited">
                National Parks({this.state.totalCount})
              </IonSegmentButton>
            </IonSegment>
            <IonButtons slot="end">
              <IonButton onClick={this.presentFilter}>
                <IonIcon icon={optionsIcon} slot="icon-only" />
              </IonButton>
            </IonButtons>
          </IonToolbar>
          <IonToolbar color="primary">
            <IonSearchbar
              placeholder="Search"
              onIonChange={this.updateSearchTerm}
            >
            </IonSearchbar>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonRefresher closeDuration="2000ms" slot="fixed" onIonRefresh={(e: CustomEvent) => this.doRefresh(e)}>
            <IonRefresherContent></IonRefresherContent>
          </IonRefresher>
          {/*<IonToast
            isOpen={this.state.isRefreshing}
            message="Updating content"
            showCloseButton={true}
            duration={2000}
            onDidDismiss={() => this.setState(() => ({ isRefreshing: false }))}
          ></IonToast>*/}

          <PlaceList
            places={this.props.placesOnDisplayInHome}
            listType={"all"}
            hidden={this.state.loadingMore}
          />
          <IonInfiniteScroll
            disabled={this.props.allFiltered.length <= this.props.placesOnDisplayInHome.length}
            threshold="100px" onIonInfinite={this.loadMoreParks}>
            <IonInfiniteScrollContent
              loadingSpinner="bubbles"
              loadingText="Loading more data..." />
          </IonInfiniteScroll>
          <SkeletonLoading loading={this.state.loadingMore} />
        </IonContent>
        <IonModal
          isOpen={this.state.showFilterModal}
          onDidDismiss={this.dismissFilter}
        >
          <PlaceListFilter
            filteredStates={this.props.stateFilters}
            allTags={this.props.allTags}
            updateStateFilters={this.updateStateFilter}
            dismissModal={this.dismissFilter}
          />
        </IonModal>
        <IonAlert
          // isOpen={this.props.needUpdate}
          isOpen={!this.props.isUpdated}
          message={'There is a new update available.'}
          buttons={[
            {
              text: 'Update',
              handler: () => {
                window.open('https://play.google.com/store/apps/details?id=com.national.parks.passport');
              }
            }
          ]}
          />
      </IonPage>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  tokens: state.users.tokens,
  isUpdated: selectors.app.isUpdated(state.app),
  allFiltered: selectors.places.allFiltered(state.places),
  loading: state.places.loading,
  loadingMore: state.places.loadingMore,
  searchText: state.places.searchTextInHome,
  filteredTags: state.places.tagFilters,
  stateFilters: state.places.stateFilters,
  allTags: selectors.places.allTags(state.places),
  total: state.places.total,
  placesOnDisplayInHome: selectors.places.allFilteredPlacesOnHomeView(state.places),
});

const mapDispatchToProps = {
  refreshTokens: (refresh_token: string) => actions.users.refreshTokens(refresh_token),
  setTokens: (tokens: Token) => actions.users.setTokens(tokens),
  checkApp: () => actions.app.checkApp(),
  fetchAllParks: () => actions.places.fetchAllParks(),
  updatePlaces: () => actions.places.updatePlaces(),
  showPlacesOnDisplay: (items: Place[]) => actions.places.showPlacesOnDisplay(items),
  getMyList: () => actions.places.getMyList(),
  searchPlaces: (searchText: string) => actions.places.setSearchTextInHome(searchText),
  updateStateFilters: (trackList: string[]) => actions.places.updateStateFilters(trackList)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withIonLifeCycle(HomePage));
